var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpsetx404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 225,
    height: 165,
    viewBox: "0 0 225 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1954",
    "data-name": "Rectangle 1954",
    width: 60.373,
    height: 97.265,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ca2af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3d1d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Blockhead-404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 165
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Blockhead-404",
    clipPath: "url(#clip-Blockhead-404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_404-UpsetX-Ballon",
    "data-name": "404-UpsetX-Ballon",
    transform: "translate(48.721 -10.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(0 95.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M1979.933,1102.339s-10.9-.868-16.313-7.553a53.8,53.8,0,0,1-7.716-12.487",
    transform: "translate(-1951.547 -1078.362)",
    fill: "none",
    stroke: "#8ca2af",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    "data-name": "Rectangle 1914",
    width: 6.866,
    height: 5.722,
    rx: 2,
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 0, 3.117)",
    fill: "#8ca2af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(102.866 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1126-2",
    "data-name": "Path 1126",
    d: "M1955.9,1102.339s10.9-.868,16.313-7.553a53.8,53.8,0,0,0,7.716-12.487",
    transform: "translate(-1955.904 -1078.362)",
    fill: "none",
    stroke: "#8ca2af",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914-2",
    "data-name": "Rectangle 1914",
    width: 6.866,
    height: 5.722,
    rx: 2,
    transform: "matrix(-0.891, -0.454, 0.454, -0.891, 25.789, 8.215)",
    fill: "#8ca2af"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 59,
    cy: 3.5,
    rx: 59,
    ry: 3.5,
    transform: "translate(3.279 162.815)",
    fill: "#ced9dd",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 87,
    height: 87,
    rx: 2,
    transform: "translate(21.779 79.815)",
    fill: "#c3d1d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 134.405, 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M9.618,2.593s9.094,4.461,8.3,7.072-8.3.544-8.3.544,1.364,2.829.4,3.7S5.242,9.23,4.048,10.318s5.172,6.256,3.581,8.649-4.888.381-4.888.381,3.979,4.08,2.955,6.419-5.57.6-5.57.6S-.727,31.534,2,32.893s16.313,0,16.313,0L32.07,4.769,31.1,0Z",
    transform: "translate(16.338 19.249)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M8.689,8.131S16.268-.283,27.938.007s18.2,7.664,16.219,15.812S40.381,24.828,31.3,29.448l-4.9,2.714s.842,5.563.212,8.319-5.5,5.657-5.2,7.833,4.7,7.108,3.789,8.7-4.85,2.031-5,1.6-.455-2.031-.455-2.031-2.274,2.929-3.486,2.19-.3-2.335-.3-2.335-3.335,1.306-3.638.29,3.183-2.756,3.031-5.367-5-7.108-7.882-8.7-8.033-1.6-7.427-10.3c0,0,3.183,6.383,6.67,5.222s2.425-3.917,2.425-3.917,2.425,3.191,4.547.725-.758-8.559-.758-8.559,5.3,2.611,5.911,1.015-4.7-4.642-4.7-4.642,6.213-2.176,7.957-3.772.683-4.352.683-4.352A7.843,7.843,0,0,0,25.419,8.45S14.9,10.742,8.689,8.131",
    transform: "translate(16.169 13.874)",
    fill: "#c3d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M4.849,2.32a2.374,2.374,0,0,1-2.425,2.32A2.374,2.374,0,0,1,0,2.32,2.374,2.374,0,0,1,2.424,0,2.374,2.374,0,0,1,4.849,2.32",
    transform: "translate(47.125 19.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M.879,33.853c-.292,0-.482-.016-.515-.019A.391.391,0,0,1,0,33.413a.4.4,0,0,1,.44-.348c.033,0,3.258.27,4.258-1.74.315-.631-.006-2.441-.345-4.357-.581-3.281-1.3-7.364.373-9.4a3.637,3.637,0,0,1,2.7-1.259c1.879-.123,3.131.17,3.83.9.96,1,.7,2.563.435,4.216a10.276,10.276,0,0,0-.2,3.153c.287,1.758,1.085,2.964,2.134,3.225,1.367.342,3.263-.868,5.334-3.4a9.558,9.558,0,0,0,1.58-2.562,3.951,3.951,0,0,1-4-1.918,1.654,1.654,0,0,1,.325-2.109c.784-.614,2.714-.456,3.847.6a2.853,2.853,0,0,1,.894,2.423c2.307-.781,6.258-3.768,7.107-7.03A4.1,4.1,0,0,0,26.978,9.27c-3.331-2.575-5.013-.673-6.64,1.168-1.019,1.152-2.072,2.344-3.4,1.706-1.823-.873-1.491-3.489-1.169-6.02.218-1.716.443-3.491-.04-4.5C15.3.73,11.631.095,3.62,2.2a.409.409,0,0,1-.5-.271.385.385,0,0,1,.283-.475A58.362,58.362,0,0,1,9.275.281C13.5-.308,15.847.027,16.458,1.3c.579,1.209.35,3.01.108,4.917-.287,2.264-.585,4.606.729,5.235.729.349,1.4-.349,2.427-1.514,1.611-1.823,3.818-4.319,7.764-1.271a4.86,4.86,0,0,1,2,5.325c-.938,3.6-5.409,7.042-8.056,7.7a9.4,9.4,0,0,1-1.841,3.18c-2.348,2.874-4.425,4.11-6.173,3.676C12.028,28.2,11.034,26.8,10.69,24.7a10.783,10.783,0,0,1,.2-3.392c.239-1.464.466-2.847-.232-3.574-.522-.544-1.561-.758-3.179-.65a2.817,2.817,0,0,0-2.117.965c-1.454,1.767-.765,5.663-.211,8.794.392,2.216.7,3.966.278,4.818-.98,1.971-3.465,2.2-4.549,2.2M18.156,18.226a1.374,1.374,0,0,0-.786.182.943.943,0,0,0-.1,1.182,3.233,3.233,0,0,0,3.494,1.444,2.174,2.174,0,0,0-.618-2.068,2.993,2.993,0,0,0-1.985-.74",
    transform: "translate(28.013 63.412)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M1.29,7.606A6.258,6.258,0,0,1,.153,2.384C.835-.771,4.928-1.1,3.9,3.254S1.29,7.606,1.29,7.606",
    transform: "translate(23.075 0)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M3.148,3.264A22.737,22.737,0,0,0,5.308,0S8.946,4.461,7.582,7.942a6.368,6.368,0,0,1-4.434,4.026s1.705-2.394,0-3.591S-.831,3.482.306,2.285s2.842.979,2.842.979",
    transform: "translate(7.576 23.164)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M1.353.258C3.449-1.285,4.8,4.609,4.8,4.609S-3.08,3.522,1.353.258",
    transform: "translate(2.777 11.918)",
    fill: "#c3d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M5.309.056S1.035-.6.216,2.558s.843,4.787,2.4,3.808.42-2.938,1.329-3.808A6.47,6.47,0,0,0,5.309.056",
    transform: "translate(4.96 42.148)",
    fill: "#c3d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M.116.894c-.829,1.352,3.025,3.59,4.048,1.414S1.183-.847.116.894",
    transform: "translate(16.222 12.696)",
    fill: "#c3d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M.038,1.03c-.545.979,5,1.088,5.57,0S.947-.6.038,1.03",
    transform: "translate(0 23.984)",
    fill: "#8ca2af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M.9,3.248a1.839,1.839,0,0,1-.595-.065.38.38,0,0,1-.212-.507.394.394,0,0,1,.222-.207.325.325,0,0,0-.054-.028A.4.4,0,0,1,0,2.048.408.408,0,0,1,.32,1.7c.005,0,.137-.044.381-.346C1.484.382,7.087-.441,8.1.264a.615.615,0,0,1,.134.925C7.359,2.422,2.668,3.248.9,3.248m.2-1.156.029.028a.375.375,0,0,1,.109.359c1.589-.1,5.445-.791,6.262-1.64A7.84,7.84,0,0,0,5.051.869a9.639,9.639,0,0,0-3.71.956,3.013,3.013,0,0,1-.241.267",
    transform: "translate(30.38 62.986)",
    fill: "#8ca2af"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1145",
    "data-name": "Path 1145",
    transform: "translate(72.194 119.393) rotate(180)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.139200687408447 10.92195701599121 C 3.754940748214722 10.92195701599121 1.00165069103241 8.696466445922852 1.00165069103241 5.960976600646973 C 1.00165069103241 5.83656644821167 1.001230716705322 5.713026523590088 1.000810742378235 5.590486526489258 C 0.995160698890686 3.938206672668457 1.02647066116333 2.890646696090698 1.711440682411194 2.20332670211792 C 2.5184006690979 1.393606543540955 4.293830871582031 0.9999966025352478 7.139200687408447 0.9999966025352478 C 9.984570503234863 0.9999966025352478 11.76000022888184 1.393606543540955 12.56696033477783 2.20332670211792 C 13.25193023681641 2.890646696090698 13.28324031829834 3.938206672668457 13.27759075164795 5.590486526489258 C 13.27717113494873 5.713026523590088 13.2767505645752 5.83656644821167 13.2767505645752 5.960976600646973 C 13.2767505645752 8.696466445922852 10.52346038818359 10.92195701599121 7.139200687408447 10.92195701599121 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.139200687408447 1.999996185302734 C 3.821290969848633 1.999996185302734 2.758171081542969 2.569656372070312 2.419760704040527 2.909226417541504 C 2.013731002807617 3.316646575927734 1.996040344238281 4.192226409912109 2.000810623168945 5.587066650390625 C 2.001230239868164 5.710746765136719 2.001650810241699 5.835416793823242 2.001650810241699 5.960976600646973 C 2.001650810241699 6.949986457824707 2.489100456237793 7.901756763458252 3.374210357666016 8.640966415405273 C 4.363320350646973 9.467026710510254 5.700420379638672 9.921957015991211 7.139200687408447 9.921957015991211 C 8.577980041503906 9.921957015991211 9.915081024169922 9.467026710510254 10.90419101715088 8.640966415405273 C 11.7893009185791 7.901756763458252 12.2767505645752 6.949986457824707 12.2767505645752 5.960976600646973 C 12.2767505645752 5.835416793823242 12.27717018127441 5.710746765136719 12.27759075164795 5.587066650390625 C 12.28236103057861 4.192226409912109 12.26467037200928 3.316646575927734 11.85864067077637 2.909226417541504 C 11.52023124694824 2.569656372070312 10.45711040496826 1.999996185302734 7.139200687408447 1.999996185302734 M 7.139200687408447 -3.814697265625e-06 C 14.57512092590332 -3.814697265625e-06 14.2767505645752 2.668816566467285 14.2767505645752 5.960976600646973 C 14.2767505645752 9.25313663482666 11.08116054534912 11.92195701599121 7.139200687408447 11.92195701599121 C 3.197240829467773 11.92195701599121 0.001650810241699219 9.25313663482666 0.001650810241699219 5.960976600646973 C 0.001650810241699219 2.668816566467285 -0.2967195510864258 -3.814697265625e-06 7.139200687408447 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1952",
    "data-name": "Rectangle 1952",
    d: "M0,0H6A0,0,0,0,1,6,0V34.724a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(50.674 100.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1953",
    "data-name": "Rectangle 1953",
    d: "M0,0H6A0,0,0,0,1,6,0V34.724a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z",
    transform: "translate(74.674 100.5)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(49.674 100.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M1979.517,1081.587a5.378,5.378,0,0,1,3.975-1.608,5.92,5.92,0,0,1,3.953,1.538",
    transform: "translate(-1979.517 -1079.979)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M1979.517,1081.587a5.378,5.378,0,0,1,3.975-1.608,5.92,5.92,0,0,1,3.953,1.538",
    transform: "translate(-1955.54 -1079.979)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M22.936,3.937A2.072,2.072,0,0,0,25.173,6.05,2.107,2.107,0,0,0,27.41,3.937V-8.023a2.107,2.107,0,0,0-2.237-2.113,2.072,2.072,0,0,0-2.237,2.113Zm2.237,8.792a2.423,2.423,0,1,0-2.423-2.423A2.426,2.426,0,0,0,25.173,12.729Z",
    transform: "translate(40.106 60.173)",
    fill: "#666"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsetx404);
export default __webpack_public_path__ + "static/media/upsetx404.aca9ff86f6fb19e3f5e8146657d31ebf.svg";
export { ForwardRef as ReactComponent };